module.exports = __webpack_public_path__ + "static/media/background-white.0a893a40.png";